exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".libs__primaryBackground__1Gp4M {\n    background-color: #4b88f2;\n}\n\n.libs__lightBackground__1DXiW {\n    background-color: #eee;\n}\n\n.libs__whiteBackground__3RkoM {\n    background-color: white;\n}\n\n.libs__dimmedBackground__2sZF7 {\n    background-color: rgba(0, 0, 0, 0.05);\n}\n\n.libs__frostedBackground__2-LGI {\n    background-color: rgba(255, 255, 255, 0.95);\n}\n\n.libs__primaryForeground__3EvIA {\n    color: #4b88f2;\n}\n\n.libs__lightForeground__3tb6b {\n    color: rgba(255, 255, 255, 0.9);\n}\n\n.libs__softForeground__10D7g {\n    color: rgba(255, 255, 255, 0.7);\n}\n\n.libs__darkForeground__1Oj3D {\n    color: rgba(0, 0, 0, 0.7);\n}\n\n.libs__dimmedForeground__1Btbr {\n    color: rgba(0, 0, 0, 0.5);\n}\n\n.libs__lightFill__2hZfp {\n    fill: rgba(255, 255, 255, 0.9);\n}\n", ""]);

// exports
exports.locals = {
	"primaryBackground": "libs__primaryBackground__1Gp4M",
	"lightBackground": "libs__lightBackground__1DXiW",
	"whiteBackground": "libs__whiteBackground__3RkoM",
	"dimmedBackground": "libs__dimmedBackground__2sZF7",
	"frostedBackground": "libs__frostedBackground__2-LGI",
	"primaryForeground": "libs__primaryForeground__3EvIA",
	"lightForeground": "libs__lightForeground__3tb6b",
	"softForeground": "libs__softForeground__10D7g",
	"darkForeground": "libs__darkForeground__1Oj3D",
	"dimmedForeground": "libs__dimmedForeground__1Btbr",
	"lightFill": "libs__lightFill__2hZfp"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[folder]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib!./client/src/style/libs/colors.css
// module id = apBb
// module chunks = 0